export enum CompanyMessageTypes {
    GeneralUserMessage = "GeneralUserMessage",
    PackageDelivery = "PackageDelivery",
    Announcement = "Announcement",
}